import { Injectable } from '@angular/core';
import {Observable, map, take, tap} from 'rxjs';
import { OepApiService } from './oep-api.service';
import { OepModule } from '../models/oep-module.class';
import { ElementDto, IomDto, ProfileDto, StepSideEnum } from '@rsmu/oep-api';
import { EducationModuleTitleInterface } from '../models/interfaces/education-module-title.interface';
import { OepStep } from '../models/oep-step.class';
import { ActionInterface } from '../models/interfaces/action.interface';
import { ActionTypeEnum } from '../models/enums/action-type.enum';
import { ActionConfig } from '../models/interfaces/action-config.interface';
import { Course } from '../models/interfaces/course.interface';

@Injectable({
  providedIn: 'root'
})
export class IomModuleService {

  backUrl: any;
  title?: string;
  type?: string;
  showResetBtn?: boolean = false;

  get totalScore(): number | undefined {
    return this._totalScore;
  }

  private _totalScore?: number;

  constructor(
    private readonly oep: OepApiService,
  ) {}

  clearIom$(iomId: string) {
    return this.oep.clearIom$(iomId);
  }

  getAction$(iomId: string,  options: ActionConfig, elementId?: string, side?: StepSideEnum): Observable<ActionInterface | null> {
    return ((elementId && side) ?
      this.oep.getButton$(iomId, elementId, side) :
      this.oep.getButton$(iomId))
      .pipe(map(stepDto => {
        if(!stepDto) {
          return null;
        }
        const action: ActionInterface = {
          type: options.type || ActionTypeEnum.ROUTER_LINK,
          link: stepDto.id,
          enabled: !stepDto.enabled,
          title: options.title,
          matColor: options.matColor,
          icon: options.icon,
          side: options.side
        }
        return action;
      }));
  }

  getBtzVariantProtocol$(variantId: string) {
    return this.oep.getBtzVariantProtocol(variantId)
  }

  getTitle$(iomId: string): Observable<EducationModuleTitleInterface>  {
    return this.oep.getTitle$(iomId)
      .pipe(
        tap(iomTitle => {
          this.title = iomTitle.name;
          this.type = iomTitle.type?.name;
          this.showResetBtn = iomTitle.showResetBtn;
        }),
        map(iomTitle => ({
          id: iomTitle.id || '',
          title: iomTitle.name || '',
          type: iomTitle.type?.shortName || iomTitle.type?.name || ''
      })))
  }

  getModule$(iomId: string) {
    return this.oep.getModule$(iomId)
      .pipe(map((iomDto: IomDto) => {
        const {id, name} = iomDto;
        const steps = iomDto.elements?.map(el => OepStep.parseStepRecursiveFromDto(el)) || [];
        return new OepModule (
          id || '',
          name || '',
          'Образовательный модуль',
          steps
        ).steps
      }))
  }

  getStepById$(iomId: string, elementId: string): Observable <OepStep> {
    return this.oep.getStepById$(iomId, elementId)
    .pipe(
      map((elementDto: ElementDto | null) => {
        if(!elementDto) {
          throw new Error('loading the elementDto is impossible: iomId = ' + elementId);
        }
        return OepStep.parseStepRecursiveFromDto(elementDto);
      })
    )
  }

  setBlockViewed$ (iomId: string, blockId: string): Observable<void> {
    return this.oep.markBlockViewed(iomId, blockId);
  }

  checkTotalScore(iomId: string) {
    this.oep.getTotalScore(iomId)
    .pipe(take(1))
    .subscribe(totalScore => this._totalScore = totalScore.score);
  }

  getProfile$(): Observable<ProfileDto> {
    return this.oep.getProfile$();
  }

  getAllCourses(): Observable<Course[]> {
    return this.oep.getAllCourses() as Observable<Course[]>;
  }
}
